import React from 'react';
import { defaultListProps } from '~constants/config';
import { List, TextField, ImageField, EditButton, DeleteWithConfirmButton } from 'react-admin';
import CustomDatagrid from '~components/CustomDatagrid';

function PaisList({ ...props }) {
  return (
    <List {...defaultListProps} {...props}>
      <CustomDatagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="code" />
        <ImageField source="flag" />
        <DeleteWithConfirmButton label="" />
        <EditButton label="" />
      </CustomDatagrid>
    </List>
  );
}

export default PaisList;
